export const ChoosePages = {
  "Modal": {
    "Title": "Choose Pages",
    "NewTitle": "Page Selection"
  },
  "Label": {
    "PageRange": "Page Range",
    "Pages": "Pages",
    "Preview": "Preview",
    "Subset": "Subset",
    "Name": "Name",
    "All": "ALL"
  },
  "Msg": {
    "PageInfo": "of {pageCount} Pages",
    "PageCountMsg": "of {pageCount}",
    "SelectAllMsg": "All pages in range",
    "EvenPagesMsg": "Even pages",
    "OddPagesMsg": "Odd pages",
    "DoubleClickTip": "Double Click To Adjust",
    "SampleMsg": "Sample:1,5-9,12",
    "TooltipMsg": "If you want to choose pages 3, 5 and 8, enter \"3,5,8\" in the text box. If you want to choose pages from 3 to 8, enter \"3-8\" in the text box."
  },
  "Button": {
    "OK": "OK",
    "Cancel": "Cancel"
  }
}